import PropTypes from 'prop-types';

import { iconColorPairs } from './InvestorServicerSummary.constants';

export const iconColorPropType = PropTypes.oneOf(Object.keys(iconColorPairs));

export const fieldPropShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueNode: PropTypes.node,
  isModified: PropTypes.bool,
  authors: PropTypes.arrayOf(PropTypes.object),
});

export const entityConfigPropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node.isRequired,
  iconColor: iconColorPropType,
  isModified: PropTypes.bool,
  authors: PropTypes.arrayOf(PropTypes.object),
  fields: PropTypes.arrayOf(fieldPropShape),
}).isRequired;
